// Shared scroll-drift for floating card layers (Page Builder 2026).
//
// Any element with [data-parallax-cards] gets its [data-parallax-depth]
// children translated by scrollY * depth, so cards drift at different speeds
// as the page scrolls — same effect as the parallax hero, which keeps its own
// (earlier) implementation in hero-parallax.js. Skipped entirely for
// prefers-reduced-motion; a no-op while the layer is display:none (mobile).

const containers = document.querySelectorAll('[data-parallax-cards]');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

if (containers.length && !reducedMotion.matches) {
  const cards = [];

  containers.forEach((container) => {
    container.querySelectorAll('[data-parallax-depth]').forEach((card) => {
      cards.push(card);
    });
  });

  if (cards.length) {
    let ticking = false;

    const update = () => {
      ticking = false;

      cards.forEach((card) => {
        if (!card.offsetParent) {
          return;
        }

        const depth = parseFloat(card.dataset.parallaxDepth) || 0;

        card.style.transform = `translate3d(0, ${window.scrollY * depth}px, 0)`;
      });
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    update();
  }
}
